import { useMemo } from "react"
import { useQuery } from "urql"

import { FULL_LIST_LIMIT } from "@/constants/common"
import { GetProductAffectedCustomersDocument } from "@/graphql/codegen/graphql"
import type { ProductSourceChangeAffectedCustomer } from "@/graphql/codegen/graphql"

interface UseGetAffectedCustomersReturn {
  affectedCustomers: ProductSourceChangeAffectedCustomer[]
  isFetching: boolean
  error?: Error
}

export const useGetAffectedCustomers = (productId: number): UseGetAffectedCustomersReturn => {
  const [{ data, fetching, error }] = useQuery({
    query: GetProductAffectedCustomersDocument,
    variables: { input: { originalProductId: productId, offset: 0, limit: FULL_LIST_LIMIT } },
    pause: !productId,
  })

  const output = data?.productSourceChange.affectedCustomers

  const affectedCustomers = useMemo(
    () =>
      output?.__typename === "ProductSourceChangeAffectedCustomersSuccess"
        ? (output?.items as ProductSourceChangeAffectedCustomer[])
        : [],
    [output]
  )

  return { affectedCustomers, isFetching: fetching, error }
}
